import { render, staticRenderFns } from "./transresult.vue?vue&type=template&id=d745ab6e&"
import script from "./transresult.vue?vue&type=script&lang=js&"
export * from "./transresult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports